var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStampDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.047 8.245h-5.928v14.56h5.928c4.014 0 7.072-3.162 7.072-7.28s-3.058-7.28-7.072-7.28zm0 10.961h-2.101v-7.363h2.1c1.997 0 3.433 1.456 3.433 3.682 0 2.225-1.436 3.681-3.432 3.681zm18.144 3.599h3.994l-2.995-5.387c1.497-.832 2.475-2.35 2.475-4.14 0-2.932-2.288-5.033-5.242-5.033H26.6v14.56h3.723v-4.7h1.332l2.537 4.7zm-3.869-11.128h2.06c.915 0 1.56.686 1.56 1.643 0 .978-.645 1.643-1.56 1.623h-2.06v-3.266zm19.994 11.128h4.014l-4.804-14.56H44.99l-4.804 14.56h4.035l.624-2.1h4.846l.624 2.1zM45.802 17.5l1.456-4.95 1.477 4.95h-2.932zm20.285-5.658V8.245h-8.944v14.56h3.723v-4.992h5.117v-3.598h-5.117v-2.372h5.221zm13.56-3.598h-10.92v3.598h3.598v10.962h3.724V11.843h3.598V8.245z",
    fill: "#656B7D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.306,
    y: 3.306,
    width: 82.339,
    height: 26.12,
    rx: 0.752,
    stroke: "#656B7D",
    strokeWidth: 1.002
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26 1.754h80.431v-3.508H4.261v3.508zM87.197 4.26v24.211h3.508V4.261h-3.508zm-2.506 26.717H4.261v3.509h80.43v-3.508zM1.754 28.471V4.261h-3.508v24.21h3.508zm2.506 2.506a2.506 2.506 0 01-2.506-2.506h-3.508a6.014 6.014 0 006.014 6.015v-3.508zm82.937-2.506a2.506 2.506 0 01-2.506 2.506v3.509a6.014 6.014 0 006.014-6.014h-3.508zM84.691 1.755a2.506 2.506 0 012.506 2.506h3.508a6.014 6.014 0 00-6.014-6.014v3.508zM4.261-1.754A6.014 6.014 0 00-1.755 4.26h3.508A2.506 2.506 0 014.26 1.754v-3.508z",
    fill: "#656B7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampDraft);
export default __webpack_public_path__ + "static/media/stamp-draft.d99a4a147a04a38b0ff1468ac0dd09b8.svg";
export { ForwardRef as ReactComponent };